<template>
  <v-container fluid fill-height>
    <v-row dense>
      <v-col>
        <v-form ref="form" v-model="valid" class="mx-5 px-5">
         <v-text-field clearable v-model="searchInput" :rules="searchRules">
            <template v-slot:label>
              Search in collection
            </template>
          </v-text-field>

          <BeerSearch icon="mdi-plus" title="Add Beer to Collection" :collectionId="collectionId" @open="onAddBeer(arguments[0])"></BeerSearch>
          <BeerSearchBarcode :collectionId="collectionId" title="Add Beer to Collection" @open="onAddBeer(arguments[0])"></BeerSearchBarcode>

        </v-form>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-container fluid fill-height>
          <template v-for="beer in beers">
            <Beer v-bind="beer" :key="beer.beerId" :collectionId="collectionId" :collectionType="collectionType" @removed="removedFromCollection(beer)" @open="onBeerClick(arguments[0])" @update-amount="beer.amount=arguments[0]"/>
          </template>
        </v-container>
      </v-col>
    </v-row>
    <v-footer absolute>
      <div v-show="busy == false" ref="Bottom"><h4>...</h4></div>
    </v-footer>
  </v-container>
</template>

<script>
import Beer from '@/components/Beer.vue';
import BeerSearch from '@/components/BeerSearch.vue';
import BeerSearchBarcode from '@/components/BeerSearchBarcode.vue';

const observerOptions = {
  root: null,
  threshold: 0,
};

export default {
  name: 'Collection',
  components: {
    Beer,
    BeerSearch,
    BeerSearchBarcode,
  },
  props: {
    collectionId: Number,
  },
  data: () => ({
    loaded: false,
    alertShow: false,
    alertMessage: '',
    collectionName: '',
    beers: [],
    valid: true,
    busy: true,
    page: 0,
    pages: 0,
    debounce: null,
    collectionType: null,
    observer: null,
    searchInput: '',
    searchRules: [
      (v) => (v && v.length >= 3) || (!v) || 'Minimum 3 chars',
    ],
  }),
  methods: {
    loadBeers() {
      this.page = 0;
      this.busy = true;
      const data = {
        collectionId: this.collectionId,
      };

      this.$webConn.request('app2_get_beers', data).then((result) => {
        this.pages = result.pages;
        this.beers = result.Beers;
        this.busy = false;
      }).catch((error) => {
        alert(error.Message);
      });
    },
    loadMore() {
      if (this.pages > this.page) {
        this.busy = true;
        this.page += 1; // increment page
        const data = {
          page: this.page,
          collectionId: this.collectionId,
        };

        this.$webConn.request('app2_get_beers', data).then((result) => {
          this.pages = result.pages;
          if (result.Beers.length > 0) {
            // push doesn't seemt to work with vue data arrays
            this.beers = this.beers.concat(result.Beers);
            this.busy = false;
          } // else no more results keep busy true to stop infinite reloads
        }).catch((error) => {
          alert(error.Message);
        });
      }
    },
    loadSingle(beerId) {
      this.busy = true;

      const data = {
        collectionId: this.collectionId,
        beerId,
      };

      this.$webConn.request('app2_get_beers', data).then((result) => {
        this.pages = result.pages;
        if (result.Beers.length > 0) {
          // remove if already exists
          const foundIndex = this.beers.findIndex((beer) => beer.beerId === beerId);
          if (foundIndex > -1) {
            this.beers.splice(foundIndex, 1);
          }

          this.beers = this.beers.concat(result.Beers);
          this.busy = false;
        } // else no more results keep busy true to stop infinite reloads
      }).catch((error) => {
        alert(error.Message);
      });
    },
    detectBottom(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMore();
        }
      });
    },
    load() {
      this.collectionName = this.$store.state.collections[this.collectionId].name;
      this.$route.meta.title = this.collectionName;// dynamic meta doesn't seem to work directly in router
      this.collectionType = this.$store.state.collections[this.collectionId].type; // get collection type from array

      // obeserver for infinite scroll
      this.observer = new IntersectionObserver(this.detectBottom, observerOptions);
      this.observer.observe(this.$refs.Bottom);
      this.loaded = true;
      this.loadBeers();
    },
    onBeerClick(beerId) {
      this.$router.push({ name: 'Beer', params: { beerId } });
    },
    onAddBeer(beerId) {
      // add single
      const data = {
        amount: 1,
        beerId,
        collectionId: this.collectionId,
      };

      this.$webConn.request('app2_change_collection', data).then((result) => {
        this.loadSingle(beerId);
        // hier verderdoen load single bier doet nog raar
      }).catch((error) => {
        this.alertMessage = error.Message;
        this.alertShow = true;
      });
    },
    removedFromCollection(beer) {
      const data = {
        amount: -1,
        beerId: beer.beerId,
        collectionId: this.collectionId,
      };

      this.$webConn.request('app2_change_collection', data).then((result) => {
        if (result.amount <= 0) { // if server confirms 0 remove beer from array
          const index = this.beers.indexOf(beer);
          if (index !== -1) {
            this.beers.splice(index, 1);
          }
        }
      }).catch((error) => {
        this.alertMessage = error.Message;
        this.alertShow = true;
      });
    },
  },
  mounted() {
    if (!this.collectionId) { // if nocollection or id destroy
      this.$router.push('/');
      this.$destroy();
    } else {
      this.load();
    }

    this.$root.$on('CollectionChanged', (collectionId) => {
      if (collectionId === this.collectionId) {
        this.loadBeers();
      }
    });
  },
  created() {

  },
  watch: {
    $route() {
      if (this.loaded) {
        // reload on page activate, collection could be changed
        this.loadBeers();
      }
    },
    searchInput(val, oldVal) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (this.valid) {
          this.page = 0;
          const data = {
            collectionId: this.collectionId,
            search: val,
          };
          console.log('Reload debounce');
          this.busy = true;

          this.$webConn.request('app2_get_beers', data).then((result) => {
            this.pages = result.pages;
            this.beers = result.Beers;
            this.busy = true;
          }).catch((error) => {
            alert(error.Message);
          });
        }
      }, 1000);
    },
  },
};

</script>
